import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../../components/common/SEOHead';

const PAGE_CONFIG = {
  cleaning: {
    slug: 'hemsida-stadfirma',
    title: 'تصميم موقع لشركة تنظيف في السويد',
    metaTitle: 'موقع لشركة تنظيف في السويد مع دعم بالعربية | StartaWebb',
    metaDescription: 'موقع سويدي لشركة التنظيف يعرض hemstädning وflyttstädning وkontorsstädning والأسعار والمدن وRUT ويسهّل طلب عرض السعر، مع شرح ودعم بالعربية.',
    keywords: 'موقع شركة تنظيف السويد, hemsida städfirma, تصميم موقع städfirma, موقع flyttstädning, مصمم مواقع عربي السويد',
    eyebrow: 'لأصحاب شركات التنظيف الناطقين بالعربية',
    hero: 'موقع سويدي يشرح خدمات التنظيف ويحوّل الزيارة إلى اتصال أو طلب سعر.',
    intro: 'نتواصل معك بالعربية، ثم نبني صفحة موجهة للعميل في السويد وتستخدم أسماء الخدمات والمعلومات التي يبحث عنها قبل اختيار شركة تنظيف.',
    examples: ['Hemstädning – تنظيف المنازل', 'Flyttstädning – تنظيف بعد الانتقال', 'Kontorsstädning – تنظيف المكاتب', 'Storstädning – تنظيف شامل', 'Fönsterputs – تنظيف النوافذ', 'Trappstädning – تنظيف السلالم'],
    questions: [
      'ما الخدمات التي تقدمها الشركة فعلًا؟',
      'في أي مدن ومناطق تعمل؟',
      'هل السعر ثابت أم بالساعة أم حسب عرض السعر؟',
      'كيف يُشرح RUT والسعر قبل وبعد الخصم؟',
      'كيف يتواصل العميل أو يرسل معلومات المهمة؟',
    ],
    included: [
      'صفحة رئيسية سويدية واضحة ومتوافقة مع الهاتف',
      'قسم للخدمات مع أسماء ووصف مناسبين للسوق السويدي',
      'المدن ومناطق العمل وأوقات التواصل',
      'زر اتصال وواتساب ونموذج طلب عرض سعر',
      'شرح RUT بطريقة غير مضللة',
      'مساعدة في كتابة النصوص السويدية من معلوماتك الأساسية',
      'ربط النطاق والنشر الأساسي',
    ],
    risks: [
      'كتابة “نقدم كل أنواع التنظيف” من دون تفاصيل أو أسعار',
      'إخفاء المدن ومناطق العمل حتى يضطر العميل للسؤال',
      'وضع صور عامة لا تمثل العمل الحقيقي للشركة',
      'إرسال الإعلان إلى صفحة لا تحتوي على زر واضح أو نموذج يعمل',
    ],
    faqs: [
      { q: 'هل يجب أن نضع أسعار التنظيف؟', a: 'ليس دائمًا. يمكن وضع سعر يبدأ من مبلغ معين، سعر بالساعة، أو طلب عرض سعر عندما تختلف المساحة والحالة والتفاصيل.' },
      { q: 'هل تكتبون المحتوى السويدي؟', a: 'نساعد في صياغة النصوص السويدية اعتمادًا على معلومات الشركة وخدماتها الحقيقية. صاحب الشركة يراجعها ويؤكد صحتها قبل النشر.' },
      { q: 'هل يمكن إضافة الحجز المباشر؟', a: 'نعم إذا كانت الخدمة والتسعير يسمحان بذلك، لكن كثيرًا من شركات التنظيف تبدأ بنموذج طلب عرض سعر ثم تضيف الحجز عندما يصبح التدفق واضحًا.' },
      { q: 'هل الموقع يضمن حجوزات؟', a: 'لا. الموقع يحسن العرض والتواصل، لكن الحجوزات تعتمد أيضًا على السعر والتقييمات والمنطقة والإعلان والمتابعة.' },
    ],
    bokaNaraLabel: 'ميزانيتك محدودة؟ يمكن البدء بصفحة شركة على BokaNära',
  },
  moving: {
    slug: 'hemsida-flyttfirma',
    title: 'تصميم موقع لشركة نقل في السويد',
    metaTitle: 'موقع لشركة نقل في السويد مع دعم بالعربية | StartaWebb',
    metaDescription: 'موقع سويدي لشركة النقل يعرض flytthjälp والحمل والتركيب ومناطق العمل ويجمع معلومات المهمة لطلب عرض السعر، مع تواصل ودعم بالعربية.',
    keywords: 'موقع شركة نقل السويد, hemsida flyttfirma, flytthjälp hemsida, تصميم موقع شركة نقل, مصمم مواقع عربي السويد',
    eyebrow: 'لشركات النقل والمساعدة في الانتقال',
    hero: 'صفحة واضحة تجمع تفاصيل النقل قبل أن تبدأ سلسلة طويلة من الرسائل.',
    intro: 'نساعدك بالعربية على تنظيم الخدمات والأسعار والأسئلة، ثم نبني موقعًا سويديًا يشرح للعميل ما الذي يجب إرساله للحصول على عرض مناسب.',
    examples: ['Flytthjälp – مساعدة في الانتقال', 'Bärhjälp – حمل الأثاث والأغراض', 'Möbeltransport – نقل الأثاث', 'Montering – فك وتركيب', 'Företagsflytt – نقل الشركات', 'Bortforsling – نقل الأغراض للتخلص منها'],
    questions: [
      'عنوان البداية والنهاية والتاريخ المطلوب',
      'الطوابق والمصعد ومسافة الحمل ومكان الوقوف',
      'حجم الأثاث أو عدد الغرف والصور عند الحاجة',
      'التغليف والفك والتركيب والخدمات الإضافية',
      'هل السعر بالساعة أم عرض ثابت بعد المراجعة؟',
    ],
    included: [
      'موقع سويدي متوافق مع الهاتف ومناسب لشركة النقل',
      'صفحات أو أقسام منفصلة لخدمات النقل والحمل والتركيب',
      'عرض المدن ونطاق الخدمة ورسوم المسافة عند الحاجة',
      'نموذج طلب سعر يجمع معلومات أفضل عن المهمة',
      'زر اتصال وواتساب وبيانات الشركة',
      'مساعدة في كتابة النصوص والشروط السويدية الأساسية',
      'ربط النطاق والنشر الأساسي',
    ],
    risks: [
      'طلب رقم هاتف فقط من دون تفاصيل النقل الأساسية',
      'عدم توضيح ما إذا كان التغليف أو التركيب داخل السعر',
      'استعمال كلمة “flytt” فقط من دون تحديد نوع المهمات المقبولة',
      'إعلان سعر منخفض من دون توضيح الحد الأدنى ورسوم السيارة والمسافة',
    ],
    faqs: [
      { q: 'هل يمكن للعميل حجز النقل مباشرة؟', a: 'يمكن ذلك للمهمات الواضحة، لكن طلب عرض السعر غالبًا أكثر أمانًا لأن السعر يعتمد على العناوين والحجم والوصول والخدمات الإضافية.' },
      { q: 'هل يمكن إضافة رفع صور؟', a: 'يمكن إضافة طريقة لإرسال الصور عندما تكون ضرورية للتقدير. نوع الحل والتخزين يُحدد قبل العمل لأنه وظيفة إضافية مقارنة بالنموذج البسيط.' },
      { q: 'هل تكتبون شروط النقل؟', a: 'نساعد في تنظيم المعلومات العامة، لكن الشروط القانونية والتأمين والمسؤوليات يجب أن تؤكدها الشركة وأن تكون مطابقة لطريقة عملها.' },
      { q: 'هل الموقع مناسب لشركة تعمل في عدة مدن؟', a: 'نعم. يمكن إنشاء أقسام للمدن ومناطق العمل، لكن لا ينبغي إنشاء صفحات مكررة بلا محتوى حقيقي فقط من أجل Google.' },
    ],
    bokaNaraLabel: 'ابدأ أيضًا بصفحة شركة نقل على BokaNära عندما تحتاج حلًا أبسط',
  },
};

const process = [
  ['01', 'نجمع المعلومات الصحيحة', 'اسم الشركة والخدمات والمدن والأسعار أو طريقة حسابها والصور وطرق التواصل.'],
  ['02', 'نرتب الصفحة باللغة السويدية', 'نحول المعلومات إلى عناوين وخدمات وخطوات يفهمها العميل في السويد.'],
  ['03', 'نبني ونختبر', 'نراجع الهاتف والنموذج والروابط وسرعة الفهم قبل إرسال النسخة للمراجعة.'],
  ['04', 'توافق وتنشر', 'لا يتم النشر النهائي قبل أن تراجع بيانات الشركة والمحتوى المتفق عليه.'],
];

function trackEvent(name, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}

export default function ArabicBusinessWebsite({ type }) {
  const page = PAGE_CONFIG[type];
  if (!page) return null;

  const canonical = `https://startawebb.se/ar/${page.slug}`;
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: page.title,
      description: page.metaDescription,
      url: canonical,
      inLanguage: 'ar-SE',
      areaServed: { '@type': 'Country', name: 'Sweden' },
      provider: {
        '@type': 'ProfessionalService',
        name: 'StartaWebb',
        url: 'https://startawebb.se',
        telephone: '+46734877119',
        email: 'info@startawebb.se',
      },
      offers: {
        '@type': 'Offer',
        price: '4900',
        priceCurrency: 'SEK',
        description: 'سعر إرشادي لموقع شركة بسيط. السعر النهائي يعتمد على النطاق والوظائف ويُكتب قبل البدء.',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: page.faqs.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'StartaWebb بالعربية', item: 'https://startawebb.se/ar' },
        { '@type': 'ListItem', position: 2, name: page.title, item: canonical },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title={page.metaTitle}
        description={page.metaDescription}
        canonical={canonical}
        keywords={page.keywords}
        language="ar"
        locale="ar_SE"
        direction="rtl"
        alternateUrls={[
          { hrefLang: 'ar-SE', href: canonical },
          { hrefLang: 'x-default', href: 'https://startawebb.se/' },
        ]}
        ogAlternateLocales={['sv_SE']}
        structuredData={structuredData}
      />

      <section dir="rtl" className="relative overflow-hidden bg-gradient-to-br from-sky-50 via-white to-cyan-50 py-20 md:py-28">
        <div className="pointer-events-none absolute -right-28 -top-28 h-80 w-80 rounded-full bg-sky-200/40 blur-3xl" />
        <div className="relative mx-auto grid max-w-6xl gap-10 px-4 lg:grid-cols-[1.05fr_0.95fr] lg:items-center">
          <div>
            <nav className="mb-6 text-sm font-semibold text-slate-500" aria-label="مسار الصفحة">
              <Link to="/ar" className="hover:text-sky-700">StartaWebb بالعربية</Link>
              <span className="mx-2">/</span>
              <span>{page.title}</span>
            </nav>
            <p className="mb-5 inline-flex rounded-full border border-sky-200 bg-white px-4 py-2 text-sm font-bold text-sky-800 shadow-sm">{page.eyebrow}</p>
            <h1 className="mb-6 max-w-4xl text-4xl font-extrabold leading-[1.14] tracking-tight text-slate-950 md:text-6xl">{page.hero}</h1>
            <p className="mb-8 max-w-3xl text-lg leading-9 text-slate-600">{page.intro}</p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <Link
                to={`/ar/kontakt?behov=hemsida&bransch=${type}`}
                onClick={() => trackEvent('cta_click', { language: 'ar', page: page.slug, action: 'contact' })}
                className="inline-flex items-center justify-center rounded-xl bg-sky-700 px-7 py-4 font-bold text-white shadow-lg shadow-sky-700/20 transition hover:-translate-y-0.5 hover:bg-sky-800"
              >
                اطلب اقتراحًا لموقع شركتك
              </Link>
              <Link to="/ar/priser" className="inline-flex items-center justify-center rounded-xl border border-slate-300 bg-white px-7 py-4 font-semibold text-slate-800 transition hover:border-sky-300 hover:text-sky-800">الأسعار وطريقة العمل</Link>
            </div>
          </div>

          <aside className="rounded-3xl border border-sky-100 bg-white p-7 shadow-2xl shadow-sky-900/10 md:p-9">
            <p className="mb-3 text-sm font-bold text-sky-700">الموقع لا يبدأ بالتصميم</p>
            <h2 className="mb-5 text-2xl font-bold text-slate-950">يبدأ بإجابات واضحة عن أسئلة العميل</h2>
            <div className="space-y-3">
              {page.questions.map((item) => (
                <div key={item} className="flex gap-3 rounded-2xl bg-slate-50 p-4 leading-7 text-slate-700">
                  <span className="font-bold text-emerald-700">✓</span>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </aside>
        </div>
      </section>

      <section dir="rtl" className="bg-white py-20">
        <div className="mx-auto max-w-6xl px-4">
          <div className="mb-10 max-w-3xl">
            <p className="mb-3 font-semibold text-sky-700">الخدمات التي يمكن عرضها</p>
            <h2 className="mb-4 text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">استخدم الكلمات التي يفهمها العميل ويبحث بها</h2>
            <p className="text-lg leading-9 text-slate-600">نستعمل المصطلحات السويدية الصحيحة، مع وصف بسيط لما يشمله كل عمل. لا نضيف خدمات لا تقدمها الشركة فعلًا.</p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {page.examples.map((item) => (
              <div key={item} className="rounded-2xl border border-slate-200 bg-slate-50 p-5 font-bold text-slate-800">{item}</div>
            ))}
          </div>
        </div>
      </section>

      <section dir="rtl" className="bg-slate-50 py-20">
        <div className="mx-auto grid max-w-6xl gap-10 px-4 lg:grid-cols-[0.85fr_1.15fr]">
          <div>
            <p className="mb-3 font-semibold text-sky-700">المحتوى الأساسي</p>
            <h2 className="mb-5 text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">ما الذي يدخل عادة في الموقع؟</h2>
            <p className="leading-8 text-slate-600">هذه نقطة بداية لموقع بسيط. الصفحات واللغات والحجز والأنظمة الخاصة تُسعّر بعد تحديدها، ولا تُضاف تلقائيًا إلى السعر الإرشادي.</p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            {page.included.map((item) => (
              <div key={item} className="flex gap-3 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <span className="font-bold text-emerald-700">✓</span>
                <span className="font-semibold leading-7 text-slate-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section dir="rtl" className="bg-white py-20">
        <div className="mx-auto max-w-6xl px-4">
          <div className="mb-10 max-w-3xl">
            <p className="mb-3 font-semibold text-sky-700">من المعلومات إلى النشر</p>
            <h2 className="text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">طريقة واضحة من أربع خطوات</h2>
          </div>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
            {process.map(([number, title, text]) => (
              <article key={number} className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
                <span className="text-4xl font-extrabold text-sky-200">{number}</span>
                <h3 className="mb-3 mt-5 text-xl font-bold text-slate-950">{title}</h3>
                <p className="leading-8 text-slate-600">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section dir="rtl" className="bg-slate-900 py-20 text-white">
        <div className="mx-auto grid max-w-6xl gap-10 px-4 lg:grid-cols-2">
          <div>
            <p className="mb-3 font-semibold text-cyan-300">أخطاء تضعف الإعلان والموقع</p>
            <h2 className="mb-6 text-3xl font-bold tracking-tight md:text-4xl">لا تدفع لجلب الزائر إلى صفحة ناقصة</h2>
            <div className="space-y-4">
              {page.risks.map((item) => (
                <div key={item} className="rounded-2xl border border-slate-700 bg-slate-800 p-5 leading-8 text-slate-300">× {item}</div>
              ))}
            </div>
          </div>
          <div className="rounded-3xl border border-slate-700 bg-slate-800 p-8">
            <p className="mb-3 font-semibold text-cyan-300">السعر الإرشادي</p>
            <p className="mb-2 text-5xl font-extrabold" dir="ltr">حوالي 4,900 kr</p>
            <p className="mb-6 leading-8 text-slate-300">لموقع شركة بسيط بالمحتوى الأساسي. السعر النهائي يعتمد على عدد الصفحات واللغات والحجز والتكاملات والمواد المتوفرة.</p>
            <Link to={`/ar/kontakt?behov=hemsida&bransch=${type}`} className="block rounded-xl bg-sky-600 px-6 py-4 text-center font-bold text-white transition hover:bg-sky-500">أرسل معلومات الشركة للحصول على تقييم</Link>
            <p className="mt-4 text-center text-xs leading-6 text-slate-400">لا يبدأ العمل قبل قبول نطاق مكتوب وسعر واضح.</p>
          </div>
        </div>
      </section>

      <section dir="rtl" className="bg-white py-20">
        <div className="mx-auto grid max-w-6xl gap-8 px-4 lg:grid-cols-[1fr_0.9fr]">
          <div>
            <p className="mb-3 font-semibold text-sky-700">أسئلة شائعة</p>
            <h2 className="mb-8 text-3xl font-bold tracking-tight text-slate-950 md:text-4xl">معلومات قبل طلب الموقع</h2>
            <div className="space-y-4">
              {page.faqs.map((item) => (
                <details key={item.q} className="rounded-2xl border border-slate-200 bg-slate-50 p-5 open:bg-white open:shadow-sm">
                  <summary className="cursor-pointer font-bold text-slate-950">{item.q}</summary>
                  <p className="mt-4 leading-8 text-slate-600">{item.a}</p>
                </details>
              ))}
            </div>
          </div>

          <aside className="h-fit rounded-3xl border border-sky-100 bg-gradient-to-br from-sky-50 to-cyan-50 p-8">
            <h2 className="mb-4 text-3xl font-bold text-slate-950">لديك معلومات بسيطة فقط؟ هذا يكفي للبداية.</h2>
            <p className="mb-7 leading-8 text-slate-600">أرسل اسم الشركة والمدن والخدمات ورقم التواصل ورابط Facebook أو Google إن وُجد. سنخبرك بما ينقص قبل تقديم الاقتراح.</p>
            <Link to={`/ar/kontakt?behov=hemsida&bransch=${type}`} className="block rounded-xl bg-sky-700 px-6 py-4 text-center font-bold text-white transition hover:bg-sky-800">ابدأ الطلب بالعربية</Link>
            <a href="https://bokanara.se/ar/foretag" target="_blank" rel="noopener noreferrer" className="mt-3 block rounded-xl border border-sky-200 bg-white px-6 py-4 text-center text-sm font-bold text-sky-800 transition hover:border-sky-400">{page.bokaNaraLabel}</a>
          </aside>
        </div>
      </section>
    </>
  );
}
